<template>
    <h1>{{competencyLabel}}</h1>
    <CompetencyManagementTable 
        :competency-label="competencyLabel"
        competency-type="personal"
        :fetch-method="(filters) => PersonalCompetencies.all(filters)"
    />
</template>

<script setup>
import CompetencyManagementTable from "@/components/assessments/competencies/CompetencyManagementTable.vue";
import PersonalCompetencies from "@/api/assessments/competencies/PersonalCompetencies.js";

const competencyLabel = "Competências Pessoais"
</script>
